import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import DirectDebitMandateCreation from './DirectDebitMandateCreation';
import DirectDebitMandateList from './DirectDebitMandateList';

export interface DirectDebitMandatesProps {
  match: {
    url: string;
  };
}

const DirectDebitMandates: FC<DirectDebitMandatesProps> = ({
  match: { url: root },
}) => {
  return (
    <Switch>
      <Route component={DirectDebitMandateCreation} path={`${root}/add`} />
      <Route
        component={DirectDebitMandateList}
        path={`${root}/:directDebitMandateId?`}
      />
    </Switch>
  );
};

export default DirectDebitMandates;
